import { render, staticRenderFns } from "./author-withdraw.vue?vue&type=template&id=1406bd52&scoped=true"
import script from "./author-withdraw.vue?vue&type=script&lang=js"
export * from "./author-withdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1406bd52",
  null
  
)

export default component.exports